module.exports = __webpack_public_path__ + "static/media/voltgroom-replacement-blade-3.b25b0742.png";